// extracted by mini-css-extract-plugin
export default {"layout":"bc909d6fb9 e157d35018 _03ad048179","h_slide":"a7b2d75461","category":"b243546520 _169b46d2ef _388cfa0d35"};